module.exports = __webpack_public_path__ + "fonts/VetoSans-BoldItalic.26a74771.ttf";